import React from "react";
import "./CustomiseWeb.css";

export default function CustomiseWeb({ heading, subheading, data }) {

  return (
    <div className="customiseweb__main__container">
      <div className="customiseweb__container">
        <p className="heading1">{heading}</p>
        {subheading ?
          <p className="subheading">{subheading}</p> : null
        }
        <div className="customiseweb__content">
          <div className="customiseweb__gridcontent">
            {
              data.map((item) => {

                return (
                  <a href={`#${item.heading}`} className="customiseweb__listitem" >
                    <img src={item.icon} />
                    <p>{item.heading}</p>
                  </a>
                )
              })
            }
          </div>
        </div>
      </div >
    </div>

  );
}
